import type { IEquipmentMachineHourEntry } from '@/interfaces/equipments'

class EquipmentMachineHourEntryForm implements IEquipmentMachineHourEntry {
  timestamp?: string
  machineHours: number
  comments?: string

  constructor(machineHourEntry?: any) {
    this.timestamp = machineHourEntry?.timestamp
    this.machineHours = machineHourEntry?.machineHours
    this.comments = machineHourEntry?.comments
  }
}

export default EquipmentMachineHourEntryForm
